import { Grid, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Tooltip } from "@mui/material";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getAllThreatDeviceList, getAllThreatSiteList, getTopThreatTableData } from "../../../actions/Users/authenticateThreatDashboard";
import _ from "lodash";
import "./../ThreatDashboard.css"

const PopUpDeviceClickList = (props) => {
    const { authReducer, allThreatSiteListLoading, allThreatDeviceList } = props;

    const [tableData, setTableData] = useState<any>([]);

    useEffect(() => {
        let tableData = allThreatDeviceList?.data?.rows.map((item) => {
            return authReducer?.allThreatDeviceList?.data?.columns.reduce((vsd, columnitem, i) => {
                vsd[columnitem] = item[i]
                return vsd;
            }, {})
        })
        setTableData(tableData)
    }, [allThreatDeviceList])

    return (
        <div className="config-container">
            <Grid container spacing={0.5} className="reports-login-history trends-usage-table-container">

                <Grid item xs={12} sm={12} md={12} lg={12} className="TopUsersConatiner">

                    <TableContainer className="usageReports-FleetDashboard loginHistory-tableContainer">
                        <Table aria-label="simple sticky table" stickyHeader>
                            <TableHead className="usageReports-tableHead">
                                <TableRow className="UsageReports-tableRow login-tableRow">
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell new-summary-left">
                                        <span style={{ whiteSpace: "nowrap" }} className="align-items-center">
                                            <span className="login-history-dp-name font-wt-900" >Device Name</span>
                                        </span>
                                    </TableCell>
                                    <TableCell className="fleetDataTable usage-fleetDataTable login-left-align login-tableCell new-summary-left">
                                        <span style={{ whiteSpace: "nowrap" }} className="align-items-center">
                                            <span className="login-history-dp-name font-wt-900" >Count</span>
                                        </span>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            {tableData && 0 != tableData.length && !allThreatSiteListLoading ? (
                                <TableBody className="tableBody usage-tableBody Table-Body-Opacity">
                                    {
                                        tableData && tableData.map((item, i) =>
                                            <TableRow key={i} className="loginHistory-tableRow new-summary-usage-tr Table-Row-Opacity">
                                                {/* <TableCell className="login-left-align inter-font selectedClick Table-Cell-Opacity" onClick={() => handleSiteClick({k4Id: item?.k4Id, x: item?.name})}>{item?.name}</TableCell> */}
                                                <Tooltip title={<span style={{ fontSize: "12px" }}>{item?.Device_Name ? item?.Device_Name : 'no data'}</span>}>
                                                    <TableCell className="login-left-align inter-font Table-Cell-Opacity elipseThreat">{item?.Device_Name ? item?.Device_Name : '-'}</TableCell>
                                                </Tooltip>
                                                <Tooltip title={<span style={{ fontSize: "12px" }}>{item?.total_hits ? item?.total_hits : 'no data'}</span>}>
                                                    <TableCell className="login-left-align inter-font Table-Cell-Opacity elipseThreat">{item?.total_hits ? item?.total_hits : '-'}</TableCell>
                                                </Tooltip>
                                            </TableRow>
                                        )
                                    }
                                </TableBody>
                            ) : (
                                <TableBody>
                                    <TableRow>
                                        <TableCell colSpan={6} className="noDataAvailableCss" align="center">No data available</TableCell>
                                    </TableRow>
                                </TableBody>
                            )}
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </div>
    )
}

const mapStateToProps = (state) => ({
    authReducer: state.authReducer,
    allThreatSiteListLoading: state?.authReducer?.allThreatSiteListLoading,
    allThreatDeviceList: state?.authReducer?.allThreatDeviceList,
    allTheratDeviceListLoading: state?.authReducer?.allTheratDeviceListLoading,
});

export default withRouter(
    connect(mapStateToProps, { getTopThreatTableData, getAllThreatSiteList, getAllThreatDeviceList })(PopUpDeviceClickList)
)